module.exports = __webpack_public_path__ + "img/hub.65aca327.png";